import ShareTool from './component';
/* eslint-disable no-new */

new ShareTool({
  target: document.getElementById('sharetool-container')
});